import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';

class InputField extends React.Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    if(this.props.onChange){
      this.props.onChange(e);
    }
  }

  componentDidMount() {
    if(this.props.focus == true) {
      let reference = this.props.reference;
      this.refs.focusOn.focus();
    }
  }

  render(){
    const { errorMessage } = this.props;
    const error = errorMessage != null;
    return (
      <div className={cx(styles.wrapper, {[styles.error]: error }, this.props.className)}>
        <div className={cx(styles.field)}>
          <label className={styles.titleLabel}>{this.props.title}</label>
          <span className={styles.inputField}>
            <input type={this.props.type ? this.props.type : "text"}
              ref={this.props.reference}
              placeholder={this.props.placeholder}
              value={this.props.value}
              onChange={this.handleChange}
              disabled={this.props.disabled}
              maxLength="500"
              spellCheck={this.props.spellCheck}
              onFocus={function(e) {
                var val = e.target.value;
                e.target.value = '';
                e.target.value = val;
              }}/>
          </span>
          {this.props.suffix &&
            <span className={styles.suffix}>{this.props.suffix}</span>  
          }
        </div>
        {errorMessage && (
        <span className={cx(styles.errorMessage, this.props.errorStyle)}>
          <i className="paperflite-danger" />
          {errorMessage}
        </span>
      )}
      </div>
    );
  }
}

InputField.defaultProps = {
  reference:'inputField',
  spellCheck: 'false',
}

export default InputField;